/* global axios */
import ApiClient from './ApiClient';

class AiCampaignTargets extends ApiClient {
  constructor() {
    super('ai/campaign_targets', { accountScoped: true });
  }

  // GET /ai/campaign_targets?inbox_id=:inboxId
  // → { available, reason, targets: [{ type, tool_name?, flow_key?, label, description }] }
  // available:false + reason quando o inbox não tem projeto de IA / produção /
  // fluxo publicado — nesse caso o seletor de destino não deve aparecer.
  get({ inboxId } = {}) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }
}

export default new AiCampaignTargets();
